import type { FaireProductEntity } from "../../entity_types/product";

export const p_sjtwbgusgw: FaireProductEntity = {
  token: "p_sjtwbgusgw",
  type: "product",
  name: "Soft Plush Sleep Eye Mask for Men & Women",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/9d2e2df061af923949f456a3c5d3303b93ac28b858fa9a0977b558c8b8770314.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9f12d7bd5ba52e98bfa3ab8d0014a5ea03f9ffa032f99f6348150629362f9b8.jpeg",
    "https://cdn.faire.com/fastly/de6e7cd9dfa8e247203c7f6c4492747bd937ab1ab829d2e080d70a89c76bd68a.jpeg",
    "https://cdn.faire.com/fastly/f35e2a27444fc5c0202f01f63560f94b134c397fa928f7383e93ce4dbbd89c6c.jpeg"
  ],
  priceDollars: 18,
  description: "For those do-not-disturb moments, our Marshmallow Eye Mask has you covered. (Literally.) Unlike ordinary eye masks, this one covers your ears, providing complete light obscurity and an added layer of noise cancelling for serene sleep.\n\nDouble lined with our plush Marshmallow fabric on both sides, it promises an ultra-soft touch against your skin, enhancing your comfort as you drift off. Its versatility makes it perfect for both home use and travel so you find tranquility wherever you are.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• Lavish marshmallow eye mask\n• Complete light obscurity\n• Nose outline with soft, elasticized band",
  tags: [],
  msrpDollars: 36,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:17.012Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
